import React from 'react';
import {
  TitleField,
  TextField,
  PhoneNumberField,
  TextAreaField,
  CardUploadField,
  DatePickerField,
} from 'components/Molecules/FormFields/index';
import { Row, Col } from 'antd';
import T from 'i18n-react';

const GccCpcGeneralInformation = () => {
  return (
    <>
      <TitleField level={5}>Identification of the product covered by this certificate</TitleField>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.productName"
            label="Product Name"
            required
          />
        </Col>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.productModel"
            label="Product / Model / Batch Number"
            required
          />
        </Col>
      </Row>
      <TextField
        placeholder={T.translate('placeholder.fillHere')}
        name="general.productBarcode"
        label="Tracking Label / Barcode"
      />
      <TextField
        placeholder={T.translate('placeholder.fillHere')}
        name="general.productDescription"
        label="Product Description"
      />
      <CardUploadField
        name="general.productPictures"
        title="Product Pictures"
        uploadBtnText="Add Photo"
      />
      <TitleField level={5}>
        Identification of the domestic manufacturer or importer certifying compliance of the product
      </TitleField>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.companyName"
            label="Name"
            required
          />
        </Col>
        <Col span={12}>
          <PhoneNumberField name="general.companyPhone" label="Phone Number" required />
        </Col>
      </Row>
      <TextField
        placeholder={T.translate('placeholder.fillHere')}
        name="general.companyAddress"
        label="Address"
        required
      />
      <TitleField level={5}>
        Contact information for the individual maintaining records of test results
      </TitleField>
      <TextField name="general.contactName" label="Contact Person" required />
      <TextField name="general.contactAddress" label="Address" required />
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <PhoneNumberField name="general.contactPhone" label="Phone Number" required />
        </Col>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.contactEmail"
            label="E-mail Address"
            required
            type="email"
          />
        </Col>
      </Row>
      <TitleField level={5}>Date and place of manufacture</TitleField>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <DatePickerField name="general.manufactureDate" label="Date of Manufacture" required />
        </Col>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.manufacturePlace"
            label="Place of Manufacture"
            required
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.manufactureName"
            label="Name of Manufacturer"
          />
        </Col>
        <Col span={12}>
          <PhoneNumberField name="general.manufacturePhone" label="Phone Number of Manufacturer" />
        </Col>
      </Row>
      <TitleField level={5}>Remark</TitleField>
      <TextAreaField
        placeholder={T.translate('placeholder.fillHere')}
        name="general.remark"
        label="Remark"
      />
    </>
  );
};

export default GccCpcGeneralInformation;
